const queuedNotifications: string[] = [];

const DEFAULT_NOTIFICATION_DELAY = 3000;
const TIME_BETWEEN_NOTIFICATIONS = 300;

export function popupNotification({
	text,
	color,
	delay,
}: {
	text: string;
	color?: 'primary' | 'warning' | 'success' | 'error';
	delay?: number;
}) {
	const delayInMiliseconds = delay || DEFAULT_NOTIFICATION_DELAY;

	// Select the body and inject a fixed element that says "notification"
	const body = document.querySelector('body');

	const notificationElement = document.createElement('div');
	notificationElement.style.position = 'fixed';
	notificationElement.style.top = '-1000px';
	notificationElement.style.zIndex = '1400';
	notificationElement.style.left = '50%';
	notificationElement.style.transform = 'translateX(-50%)';
	notificationElement.style.backgroundColor = color
		? `var(--color-main-${color})`
		: '#36304a'; // Dark background color
	notificationElement.style.color = color
		? `var(--color-contrast-${color})`
		: 'white';
	notificationElement.style.padding = '12px 24px';
	notificationElement.style.borderRadius = '8px';
	notificationElement.style.textAlign = 'center'; // Center-align text
	notificationElement.style.display = 'flex';
	notificationElement.style.alignItems = 'center';
	notificationElement.style.justifyContent = 'space-between';
	notificationElement.style.gap = '16px';

	// Slide down animation
	notificationElement.style.animation = 'slide-top-down 0.5s ease-in-out';

	// Create p element with text
	const notificationText = document.createElement('p');
	notificationText.style.margin = '0';
	notificationText.innerText = text;
	notificationElement.appendChild(notificationText);

	// Append "x" icon to the notification through an "i" element with the classes "fa-solid fa-xmark"
	const notificationIcon = document.createElement('i');
	notificationIcon.classList.add('fa-solid', 'fa-xmark');
	notificationIcon.style.cursor = 'pointer';

	const onIconClick = (e: MouseEvent) => {
		e.stopPropagation();
		notificationElement.remove();
	};

	notificationIcon.addEventListener('click', onIconClick);

	notificationElement.appendChild(notificationIcon);

  const milisecondsUntilShow =
		queuedNotifications.length * delayInMiliseconds +
		(queuedNotifications.length ? TIME_BETWEEN_NOTIFICATIONS : 0);

	const milisecondsUntilRemove = milisecondsUntilShow + delayInMiliseconds;

	const uuid =
		Math.random().toString(36).substring(2, 15) +
		Math.random().toString(36).substring(2, 15);

	queuedNotifications.push(uuid);

	// Display the notification for 3 seconds before removing it
	setTimeout(() => {
		notificationElement.remove();
		notificationIcon.removeEventListener('click', onIconClick);
		queuedNotifications.splice(queuedNotifications.indexOf(uuid), 1);
	}, milisecondsUntilRemove);

	setTimeout(() => {
		body.appendChild(notificationElement);

    setTimeout(() => {
    	notificationElement.style.top = '16px';
    }, 100);
	}, milisecondsUntilShow);

}
